import styled from 'styled-components';
import imageIcon from '../../icons/icon-image-download.svg';
import videoIcon from '../../icons/icon-video-download.svg';
import timelapseIcon from '../../icons/icon-timelapse-download.svg';

export const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  max-width: 328px;
  width: 100%;
  margin: 0 auto 13px;
`;

export const StyledButton = styled.button`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  text-align: center;
  padding: 8px 0;
  position: relative;
  width: calc(33% - 20px);
  background: ${({ $backgroundColor }) => $backgroundColor || '#000'};
  color: ${({ $textColor }) => $textColor || '#fff'};
  outline: none;
  border: none;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: -0.6px;
  z-index: 2;
  cursor: pointer;
  border-radius: 8px;

  &::before {
    content: '';
    border-radius: 8px;
    border: 2px solid transparent;
    background-image: linear-gradient(
        ${({ $backgroundColor }) =>
          `${$backgroundColor || '#000'}, ${$backgroundColor || '#000'}`}
      ),
      linear-gradient(
        to bottom,
        ${({ $borderGradientTop }) => $borderGradientTop || '#fff'} 0%,
        ${({ $borderGradientBottom }) => $borderGradientBottom || '#fff'} 100%
      );
    background-origin: border-box;
    background-clip: content-box, border-box;
    box-sizing: border-box;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 0;
  }

  * {
    font-family: 'HiraKaku', 'HGGGothicssi', 'Pretendard', 'Noto Sans',
      sans-serif;
    white-space: pre;
    z-index: 2;
  }

  i {
    width: 24px;
    height: 24px;
    background-color: ${({ $textColor }) => $textColor || '#fff'};

    &.image {
      -webkit-mask: url(${imageIcon}) no-repeat center;
      mask: url(${imageIcon}) no-repeat center;
    }

    &.video {
      -webkit-mask: url(${videoIcon}) no-repeat center;
      mask: url(${videoIcon}) no-repeat center;
    }

    &.timelapse {
      -webkit-mask: url(${timelapseIcon}) no-repeat center;
      mask: url(${timelapseIcon}) no-repeat center;
    }
  }

  &:disabled {
    i {
      background-color: #84838d;
    }

    span {
      color: #84838d;
    }

    &::before {
      background-image: linear-gradient(
          ${({ $backgroundColor }) =>
            `${$backgroundColor || '#000'}, ${$backgroundColor || '#000'}`}
        ),
        linear-gradient(90deg, #84838d 0%, #84838d 100%);
    }
  }
`;
